
export class MediaPathHelper {

  public static imageSrcUrl(imageUrl: string, baseUrl): string {
    return imageUrl ? imageUrl.replace('/sites', `${baseUrl}/sites`) : null;
  }

  public static videoImageSrcUrl(imageUrl: string, baseUrl: string): string {
    return imageUrl ? imageUrl.replace('src="/sites', `src="${baseUrl}/sites`) : null;
  }

  public static youTubeEmbedUrl(youTubeUrl): string {
    return youTubeUrl ? youTubeUrl.replace('watch?v=', 'embed/') : null;
  }

  public static getNormalizedMedia(imageField: object, jsonDataString: string) {
    if (typeof imageField === 'undefined' || !imageField['dataset']) {
      return null;
    }

    const jsonIncludesData = JSON.parse(jsonDataString).included;

    return this.extractMediaImages(imageField['dataset'].data, jsonIncludesData);
  }
  /**
   * Grabs cropped images
   * @param imageField the json property that holds the media entity
   * @param jsonIncludesData default included property of the the json api
   * @return object containing various cropped image styles
   */
  public static getMedia(imageField: object, jsonIncludesData: object) {
    if (imageField['data'] === null) {
      return null;
    }

    return this.extractMediaImages(imageField['data'], jsonIncludesData);
  }

  private static extractMediaImages(imageData: object, jsonIncludesData: object) {
    const imageFieldUuid = imageData['id'];
    const indexedJsonData = MediaPathHelper.indexDataByUuid(jsonIncludesData);
    const fileUuid = indexedJsonData[imageFieldUuid].relationships.field_media_image ?
      indexedJsonData[imageFieldUuid].relationships.field_media_image['data'].id : imageFieldUuid;
    const croppedImages = indexedJsonData[fileUuid].links;

    return croppedImages;
  }

  public static indexDataByUuid(jsonIncludesData) {
    const indexedObjects = {};
    for (const jsonData of jsonIncludesData) {
      indexedObjects[jsonData.id] = jsonData;
    }

    return indexedObjects;
  }
}
